<div
    class="sera-image-container"
    [ngStyle]="{
        'grid-template-columns': 'repeat(' + numberOfColumns + ', min-content)',
        'column-gap': columnGapInPx + 'px',
        'row-gap': rowGapInPx + 'px',
        'justify-content': columnGapInPx ? 'none' : 'space-between'
    }">
    <sera-image
        *ngFor="let image of imageItems"
        [readOnly]="readOnly"
        [imageItem]="image"
        [transparentImage]="transparentImages"
        (imageClickEmitter)="handleImageSelection($event)">
    </sera-image>
</div>
